"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DetailItemVideo = void 0;
var VideoPlayEvent = _interopRequireWildcard(require("@ori-events/video-play"));
var _analyticsData = require("@ori/analytics-data");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DetailItemVideo = ({
  detailItem: {
    id,
    videoUrl,
    source,
    images
  }
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();

  // istanbul ignore next @preserve --Not possible to test this function
  const onVideoStart = (0, _react.useCallback)(() => {
    const customEvent = new CustomEvent(VideoPlayEvent.Name, {
      detail: {
        action: _analyticsData.VideoAction.Start,
        placement: _analyticsData.Placement.OlapicWidget,
        videoId: id,
        videoUrl,
        videoProvider: source
      }
    });
    window.dispatchEvent(customEvent);
  }, [id, source, videoUrl]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.DETAIL_ITEM_VIDEO),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.VideoPlayer, {
      loop: true,
      muted: true,
      playing: true,
      light: images.mobile,
      playIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageHolderPlay, {
        isInteractive: true
      }),
      volume: 0,
      controls: false,
      url: videoUrl,
      width: "100%",
      height: "100%",
      onStart: onVideoStart
    })
  });
};

// for lazy loading
exports.DetailItemVideo = DetailItemVideo;
var _default = exports.default = DetailItemVideo;
